import styled from 'styled-components';


const Root = styled.div`
	position: relative;
	width: 100%;
	height: auto;
	display: flex;
	align-items: flex-start;
	contain: layout;

	& .ReactVirtualized__Grid {
		outline: none;
	}

	& .ReactVirtualized__List,
	& .ReactVirtualized__Grid__innerScrollContainer {
		overflow: visible !important;
	}
`;

export {
	Root
}